import type { ExchangesState, JsonExchange } from './types';

/**
 * Slice-relative selectors. They operate on the {@link ExchangesState} slice
 * itself, not on the root store — the app composes mount-point adapters around
 * them (the exchanges slice can be mounted at different keys per channel).
 */
export const selectExchangesLoading = (state: ExchangesState): boolean =>
  state.requestStatus === 'pending';

export const selectExchangesList = (state: ExchangesState): JsonExchange[] => state.list;

export const selectExchangesError = (state: ExchangesState) => state.error;
